export default __webpack_public_path__ + "static/media/ic_arrow_foward.21228b4d.svg";